var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let BreakInDamageDescriptionSectionCard = class BreakInDamageDescriptionSectionCard extends Vue {
};
__decorate([
    Prop({ type: String, default: null })
], BreakInDamageDescriptionSectionCard.prototype, "title", void 0);
__decorate([
    Prop({ type: String, default: null })
], BreakInDamageDescriptionSectionCard.prototype, "subtitle", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BreakInDamageDescriptionSectionCard.prototype, "hasError", void 0);
BreakInDamageDescriptionSectionCard = __decorate([
    Component
], BreakInDamageDescriptionSectionCard);
export default BreakInDamageDescriptionSectionCard;
